import React, { useState } from "react";
import { useSelector } from "react-redux";
import { checkRole } from "../../utils/role";

// COMPONENTS
import LoadingPage from "../Loading/LoadingPage";
import ContainerContent from "../Container/ContainerContent";
import InterestTable from "./InterestTable";
import HolidayTable from "./HolidayTable";
import PromotionTable from "./PromotionTable";
import PointTable from "./PointTable";
import Banner from "./Banner";

// HOOKS
import useGetInterest from "../../hooks/useGetInterest";
import useGetHoliday from "../../hooks/useGetHoliday";
import useGetPromotion from "../../hooks/useGetPromotion";
import useGetBanner from "../../hooks/useGetBanner";
import useGetPoint from "../../hooks/useGetPoint";

// UTILS
import { getCurrentLocalDateTime } from "../../utils/getLocalDateTime";

function SettingsTable() {
  const { user } = useSelector((state) => state.initializeApp);

  const {
    datas: datasPoint,
    loading: loadingPoint,
    error: errorPoint,
    getData: getPoint,
  } = useGetPoint();

  const {
    datas: datasInterest,
    loading: loadingInterest,
    error: errorInterest,
    getData: getDataInterest,
  } = useGetInterest();

  const {
    datas: datasHoliday,
    loading: loadingHoliday,
    error: errorHoliday,
    getData: getDataHoliday,
  } = useGetHoliday();

  const {
    datas: datasPromotionPv,
    loading: loadingPromotionPv,
    error: errorPromotionPv,
    getData: getDataPromotionPv,
  } = useGetPromotion({ isPrivillege: true });

  const {
    datas: datasPromotion,
    loading: loadingPromotion,
    error: errorPromotion,
    getData: getDataPromotion,
  } = useGetPromotion({ isPrivillege: false });

  const {
    datas: datasBanner,
    loading: loadingBanner,
    error: errorBanner,
    getData: getDataBanner,
  } = useGetBanner();

  if (
    errorHoliday ||
    errorInterest ||
    errorPromotion ||
    errorBanner ||
    errorPromotionPv ||
    errorPoint
  )
    return <ContainerContent>Error</ContainerContent>;
  if (
    loadingHoliday ||
    loadingInterest ||
    loadingPromotion ||
    loadingBanner ||
    loadingPromotionPv ||
    loadingPoint
  ) {
    return (
      <ContainerContent>
        <LoadingPage />
      </ContainerContent>
    );
  }

  // const checkRole = () => {
  //   return user?.groups?.some((group) => ["SuperAdmin"].includes(group));
  // };

  return (
    <ContainerContent>
      <div>
        <h2 className="mx-4 font-semibold">Banner</h2>
        <Banner data={datasBanner} getData={getDataBanner} />
      </div>
      {checkRole(user.groups, ["SuperAdmin", "Marketing"]) && (
        <div>
          <div className="my-8">
            <h2 className="mx-4 font-semibold">ตารางอัตราดอกเบี้ยมาตรฐาน</h2>
            <InterestTable data={datasInterest} getData={getDataInterest} />
          </div>
          <div className="my-8">
            <h2 className="mx-4 font-semibold">ตารางคะแนนที่ได้รับ</h2>
            <PointTable data={datasPoint} getData={getPoint} />
          </div>
        </div>
      )}
      <div className="my-8">
        <h2 className="mx-4 font-semibold">
          ตารางวันหยุดเพื่อบวกเพิ่ม 30 ชั่วโมง
        </h2>
        <HolidayTable data={datasHoliday} getData={getDataHoliday} />
      </div>
      {checkRole(user.groups, ["SuperAdmin", "Marketing"]) && (
        <React.Fragment>
          <div className="my-8">
            <h2 className="mx-4 font-semibold">ตารางโปรโมชั่นแบบสิทธิพิเศษ</h2>
            <PromotionTable
              labelName="ชื่อโปรโมชั่น"
              data={datasPromotionPv}
              getData={getDataPromotionPv}
              isPrivillege={true}
            />
          </div>
          <div className="my-8">
            <h2 className="mx-4 font-semibold">ตารางโปรโมชั่นแบบวันที่</h2>
            <PromotionTable
              labelName="วันที่"
              data={datasPromotion}
              getData={getDataPromotion}
              isPrivillege={false}
            />
          </div>
        </React.Fragment>
      )}
    </ContainerContent>
  );
}

export default SettingsTable;
